module.exports = __webpack_public_path__ + "img/workshop_einstieg.c15a64f6.png";